<template>
  <div>
    <h5 class="mb-4">Vielen Dank für Ihre Angaben</h5>
    <h5>Hier eine Zusammenfassung Ihrer Buchung:</h5>
    <div class="insurance-data">
      <div class="mb-3">
        <p class="mb-1"><strong>
          <svg style="margin-top:-1px" class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 10h16m-8-3V4M7 7V4m10 3V4M5 20h14a1 1 0 0 0 1-1V7a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1Zm3-7h.01v.01H8V13Zm4 0h.01v.01H12V13Zm4 0h.01v.01H16V13Zm-8 4h.01v.01H8V17Zm4 0h.01v.01H12V17Zm4 0h.01v.01H16V17Z"/>
          </svg>
          Ihr Termin:</strong></p>
        <div v-if="selectedSlotStart">Datum/Uhrzeit: <strong>{{ selectedSlotStart | formatDateTime }}</strong></div>
        <div v-else>Kein Termin ausgewählt</div>
        <div v-if="selectedEmployee">
          <p>{{ employeeSelectedText }}: {{ selectedEmployee }} </p>
        </div>
      </div>
      <div class="mb-3" v-if="licenseplate !== 'k'">
        <p class="mb-1"><strong>
          <svg style="margin-top:-1px" class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 4h3a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3m0 3h6m-3 5h3m-6 0h.01M12 16h3m-6 0h.01M10 3v4h4V3h-4Z"/>
          </svg>
          Ihr Fahrzeug:</strong></p>
        <div v-if="licenseplate">Kennzeichen: <strong>{{ licenseplate }}</strong></div>
        <div v-else>Kein Kennzeichen angegeben</div>
        <div v-if="typeDetails.manufacturer || typeDetails.model">
          <div>
            <span v-if="typeDetails.manufacturer">Hersteller: <strong>{{ typeDetails.manufacturer }}</strong><br /></span>
            <span v-if="typeDetails.productionSeries">Modell: <strong>{{ typeDetails.productionSeries }}</strong></span>
            <span v-else-if="typeDetails.model">Modell: <strong>{{ typeDetails.model }}</strong></span>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <p class="mb-1"><strong>
          <svg style="margin-top:-1px" class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 9h3m-3 3h3m-3 3h3m-6 1c-.306-.613-.933-1-1.618-1H7.618c-.685 0-1.312.387-1.618 1M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm7 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"/>
          </svg>
          Ihre Angaben zur Versicherung:</strong></p>
        <div v-if="!insuranceData || !insuranceData.damagetype">Es wurden keine Angaben zur Versicherung gemacht</div>
        <div v-else>
          <div v-if="insuranceData.damagetype">Haftpflicht oder Kasko? <strong>{{ insuranceData.damagetype }}</strong></div>
          <div v-if="insuranceData.company">Ihre Versicherung: <strong>{{ insuranceData.company }}</strong></div>
          <div v-if="insuranceData.reported">Schaden gemeldet? <strong>{{ insuranceData.reported }}</strong></div>
          <div v-if="insuranceData.hasdamagenumber">Schadennummer erhalten? <strong>{{ insuranceData.hasdamagenumber }}</strong></div>
          <div v-if="insuranceData.damagenumber">Schadennummer: <strong>{{ insuranceData.damagenumber }}</strong></div>
        </div>
      </div>
    </div>

    <!-- Guest Booking Buttons -->
    <div class="d-sm-flex justify-content-between" v-if="!identityToken">
      <button @click="openLoginWindow" class="btn btn-primary my-1 mr-1">
        <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
          <path fill-rule="evenodd" d="M8 10V7a4 4 0 1 1 8 0v3h1a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h1Zm2-3a2 2 0 1 1 4 0v3h-4V7Zm2 6a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Z" clip-rule="evenodd"/>
        </svg>
        Weiter mit Anmeldung
      </button>
      <button @click="goToGuestAppointment" class="btn btn-primary my-1 mr-1">
        <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
          <path stroke="currentColor" stroke-width="2" d="M7 17v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3Zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
        </svg>
        Weiter als Gast
      </button>
    </div>

    <!-- Checkout for logged in users -->
    <div v-if="identityToken">

      <KSRShopAccount
        :studioId="studioId"
        :identityToken="identityToken"
        @account-status-changed="onAccountStatusChanged"
      />

      <template v-if="accountStatus && accountStatus !== 10">
        <div class="form-row">
          <div class="col-md-12">
            <p><strong><u>Bitte ergänzen Sie noch folgende Daten zu Ihrem Fahrzeug:</u></strong></p>
          </div>
        </div>

        <KSRSelectVehicle @setvehicle="setVehicle" :kit="identityToken" />

        <div class="invalid-feedback d-block invalid-vehicle" v-if="formdata_errors.includes('licenseplate')">
          Bitte wählen Sie ein Fahrzeug aus.
        </div>

        <div class="form-row">

          <div class="form-group col-md-12">
            <label class="form-label" for="description">Schadenbeschreibung<span class="text-danger">*</span>:</label>
            <textarea name="description" v-model="formdata.description" class="form-control" id="description"></textarea>
            <p class="small text-muted" v-if="!formdata_errors.includes('description')">Bitte geben Sie hier eine möglichst präzise Beschreibung Ihres Schadens an.</p>
            <div class="invalid-feedback d-block" v-if="formdata_errors.includes('description')">
              Bitte geben Sie hier eine möglichst präzise Beschreibung Ihres Schadens an.
            </div>
          </div>

        </div>

        <div class="form-group">
          <label class="form-label" for="Schadenbilder">Schadenbilder (JPG, PNG) - optional:</label>
          <vue-dropzone
              ref="myVueDropzone1"
              :useCustomSlot="true"
              id="dropzone"
              @vdropzone-upload-progress="uploadProgress"
              :options="dropzoneOptions"
              @vdropzone-file-added="fileAdded"
              @vdropzone-sending-multiple="sendingFiles"
              @vdropzone-success-multiple="success"
          ><div class="dz-message" data-dz-message><span>Dateien mit Drag & Drop hochladen oder Foto machen</span></div></vue-dropzone>
          <AttachmentList
              :tempAttachments="getTempAttachments"
              :attachments="getAttachments"
          />
        </div>

        <div class="form-group">
          <label class="form-label" for="infos">Wie und wann können wir Sie für Rückfragen erreichen<span class="text-danger">*</span>:</label>
          <textarea name="infos" v-model="formdata.infos" class="form-control" id="infos"></textarea>
          <div class="invalid-feedback d-block" v-if="formdata_errors.includes('infos')">
            Bitte geben Sie Infos für evtl. Rückfragen an.
          </div>
        </div>

        <button @click="onBookViewingAppointment" class="btn btn-primary my-1 mr-1">
          <div class="spinner-border text-white mr-2" role="status" v-if="loading">
            <span class="sr-only">Loading...</span>
          </div>
          Besichtigungstermin buchen
        </button>

        <div class="mt-4 text-danger"><small>* = Erforderlich</small></div>

      </template>

    </div>

  </div>
</template>

<script>
import AttachmentList from "./AttachmentList.vue";
import KSRSelectVehicle from "./KSRSelectVehicle.vue";
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import KSRShopAccount from "./KSRShopAccount.vue";

export default {
  name: 'KSRViewingAppointmentCheckout',
  components: {KSRSelectVehicle, AttachmentList, vueDropzone: vue2Dropzone, KSRShopAccount},
  data() {
    return {
      loading: false,
      studioId: false,
      jobId: null,
      // Data from localStorage
      selectedSlotStart: '',
      licenseplate: '',
      typeDetails: {},
      insuranceData: {},
      selectedEmployeeId: null,
      employeeSelectedText: 'Mitarbeiter',
      identityToken: '',
      formdata: {
        licenseplate:'',
        vin:'',
        brand:'',
        model: '',
        ez: '',
        description: '',
        infos: ''
      },
      formdata_errors: [],
      tempAttachments: [],
      attachments: [],
      filesAdded: [],
      tempAttachments2: [],
      accountStatus: null,
      dropzoneOptions: {
        url: '/api/ksr/upload/damages/temp',
        //autoProcessQueue: false,
        maxFilesize: 10000000,
        headers: {
          //Authorization: ``
        },
        paramName: function(n) {
          return "file[]";
        },
        dictDefaultMessage: "Dateien hier ablegen",
        includeStyling: false,
        previewsContainer: false,
        thumbnailWidth: 250,
        thumbnailHeight: 140,
        uploadMultiple: true,
        parallelUploads: 5,
        createImageThumbnails: true,
        maxThumbnailFilesize: 10,
        acceptedFiles: 'image/*,application/pdf', // needed for IOS/Android to show both camera and filebrowser
        init: function() {
          // Still enforce image-only validation
          this.on("addedfile", function(file) {
            if (!file.type.match(/^image\//)) {
              this.removeFile(file);
              alert("Nur Bilddateien sind erlaubt!");
            }
          });
        }
      }
    }
  },
  created() {

    this.studioId = this.$parent.studioId;

    // Get jobId from route parameter
    this.jobId = this.$route ? this.$route.params.jobId : null;
    //console.log('Job ID:', this.jobId);

    // Load data from localStorage
    this.loadFromLocalStorage();

    // Check for identityToken
    this.identityToken = sessionStorage.getItem('identityToken');
        
  },
  mounted() {
    //this.dropzoneOptions.url = '/api/ksr/upload/'+_this.studioId+'/'+response.data.jobId+'/'+response.data.requestId;
  },
  computed: {
    getTempAttachments() {
      return this.tempAttachments;
    },
    getAttachments() {
      return this.attachments;
    }
  },
  watch: {
    '$route'(to, from) {
      // React to route changes
      if (to.params.jobId) {
        this.jobId = to.params.jobId;
      }
    }
  },
  methods: {
    onAccountStatusChanged(status) {
      this.accountStatus = status;
    },
    loadFromLocalStorage() {
      try {
        // Load slot start time
        this.selectedSlotStart = localStorage.getItem('selectedSlotStart') || '';

        // Load selected employee
        this.selectedEmployeeId = localStorage.getItem('selectedEmployeeId') || '';

        // Load license plate
        this.licenseplate = localStorage.getItem('licensePlate') || '';

        // Load type details (JSON)
        const storedTypeDetails = localStorage.getItem('typeDetails');
        if (storedTypeDetails) {
          this.typeDetails = JSON.parse(storedTypeDetails);
        }

        // Load insurance data (JSON)
        const storedInsuranceData = localStorage.getItem('insuranceData');
        if (storedInsuranceData) {
          this.insuranceData = JSON.parse(storedInsuranceData);
        }

        console.log('Loaded checkout data from localStorage:', {
          selectedSlotStart: this.selectedSlotStart,
          selectedEmployeeId: this.selectedEmployeeId,
          licenseplate: this.licenseplate,
          typeDetails: this.typeDetails,
          insuranceData: this.insuranceData
        });

      } catch (error) {
        console.error('Error loading from localStorage:', error);
      }
    },
    goToGuestAppointment() {
      // Navigate to guest appointment
      this.$router.push('/viewing-appointment-form/' + this.jobId);
    },
    openLoginWindow(section = 'kl') {
      var w = 400;
      var h = 500;
      var left = (screen.width/2)-(w/2);
      var top = (screen.height/2)-(h/2);
      var addSectionToUrl = '';
      if(section == 'service') {
        var addSectionToUrl = '&section=service';
      }
      //https://pre.booklyn.io/s/ksrdemo.booklyn.io/ksrlogin/1
      if(window.location.href.indexOf("/s/") != -1) {
        //window.open('/s/pre.booklyn.io/ksrlogin/' + this.studioId + addSectionToUrl, 'ksrlogin', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left);
        window.open('/s/pre.booklyn.io/ksrlogin/' + this.studioId + '?cookieless' + addSectionToUrl, 'ksrlogin', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left);
      }
      else {
        //window.open('/ksrlogin/' + this.studioId + addSectionToUrl, 'ksrlogin', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left);
        window.open('/ksrlogin/' + this.studioId + '?cookieless' + addSectionToUrl, 'ksrlogin', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left);
      }
    },
    setVehicle(vehicle) {

      if(!vehicle) {
        this.formdata.brand = '';
        this.formdata.model = '';
        this.formdata.ez = '';
        this.formdata.licenseplate = '';
        this.formdata.vin = '';
        this.formdata.vehicleId = false
        /*this.formdata_offer.brand = '';
        this.formdata_offer.model = '';
        this.formdata_offer.ez = '';
        this.formdata_offer.licenseplate = '';
        this.formdata_offer.vin = '';
        this.formdata_offer.vehicleId = false;*/
      }

      this.formdata.brand = vehicle.brand;
      this.formdata.model = vehicle.model;
      if(vehicle.registration_date) {
        this.formdata.ez = moment(vehicle.registration_date).format('YYYY-MM-DD');
      }
      this.formdata.licenseplate = vehicle.licenseplate;
      this.formdata.vin = vehicle.vin;
      this.formdata.vehicleId = vehicle.id;

      /*this.formdata_offer.brand = vehicle.brand;
      this.formdata_offer.model = vehicle.model;
      this.formdata_offer.ez = moment(vehicle.registration_date).format('YYYY-MM-DD');
      this.formdata_offer.licenseplate = vehicle.licenseplate;
      this.formdata_offer.vin = vehicle.vin;
      this.formdata_offer.vehicleId = vehicle.id;*/

    },
    fileAdded(file) {
      // Construct your file object to render in the UI
      let attachment = {};
      attachment._id = file.upload.uuid;
      attachment.title = file.name;
      attachment.type = "file";
      attachment.extension = "." + file.type.split("/")[1];
      attachment.content = "File Upload by Select or Drop";
      attachment.thumb = file.dataURL;
      attachment.thumb_list = file.dataURL;
      attachment.isLoading = true;
      attachment.progress = null;
      attachment.size = file.size;
      this.tempAttachments = [...this.tempAttachments, attachment];
    },
    sendingFiles(files, xhr, formData) {
      let uuids = [];
      for(var k = 0; k < files.length; k++) {
        uuids.push(files[k].upload.uuid);
      }
      formData.append('uuids', uuids);
      formData.append('type', 'viewing-appointment');
    },
    // function where we get the upload progress
    uploadProgress(file, progress, bytesSent) {
      this.tempAttachments.map(attachment => {
        if (attachment.title === file.name) {
          attachment.progress = `${Math.floor(progress)}`;
        }
      });
    },
    // called on successful upload of a file
    success(file, response) {
      for(var i = 0; i < file.length; i++) {
        for(var k = 0; k < this.tempAttachments.length; k++) {
          if(this.tempAttachments[k]._id == file[i].upload.uuid) {
            //console.log("update");
            this.tempAttachments[k].title = response[i];
            this.tempAttachments[k].thumb = file[i].dataURL;
            this.tempAttachments[k].thumb_list = file[i].dataURL;
          }
        }
      }
    },
    async onBookViewingAppointment() {
      // Reset and validate
      this.formdata_errors = [];

      if (!this.formdata.infos.trim()) {
        this.formdata_errors.push('infos');
      }

      // Handle validation errors
      if (this.formdata_errors.length) {
        setTimeout(() => {
          document.querySelector('.invalid-feedback')?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }, 200);
        return;
      }

      // Submit booking
      this.loading = true;

      console.log('Prepare booking data');

      const bookingData = {
        tempAttachments: this.tempAttachments,
        formdata: this.formdata,
        start: this.selectedSlotStart,
        employeeId: this.selectedEmployeeId,
        insuranceData: this.insuranceData
      };

      console.log('Booking data:', bookingData);

      try {
        await axios.post(`/api/ksr/${this.studioId}/kit/confirm?identityToken=${this.identityToken}`, bookingData);
        setTimeout(function() {
          var element = document.querySelector("#booking-container");
          element.scrollIntoView();
        }, 200);
        this.$router.push('/thank-you');
      } catch (error) {
        console.error('Kit booking failed:', error);
      } finally {
        this.loading = false;
      }
    },
    goBack() {
      // Go back using hash navigation (since router might not be available)
      window.location.hash = '';
      // Alternative: this.$router.go(-1) if router is available
    }
  }
}
</script>